module.exports = __webpack_public_path__ + "static/people_img29-b1cf2406e87130f0378125cda6aff9b1.png";